const dragEvents = ['dragover', 'dragenter', 'drop'];
export function fileAccepted(file, accept) {
    return file.type === 'application/x-moz-file' || accepts(file, accept);
}
export function getDataTransferFiles(event) {
    if (isDragEvent(event) && event.dataTransfer) {
        const dt = event.dataTransfer;
        if (dt.files && dt.files.length) {
            return Array.from(dt.files);
        }
        if (dt.items && dt.items.length) {
            return Array.from(dt.items);
        }
    }
    else if (isChangeEvent(event) && event.target.files) {
        return Array.from(event.target.files);
    }
    return [];
}
function accepts(file, acceptedFiles) {
    if (file && acceptedFiles) {
        const fileName = file.name || '';
        const mimeType = file.type || '';
        const baseMimeType = mimeType.replace(/\/.*$/, '');
        const acceptedFilesArray = Array.isArray(acceptedFiles)
            ? acceptedFiles
            : acceptedFiles.split(',');
        return acceptedFilesArray.some(type => {
            const validType = type.trim();
            if (validType.startsWith('.')) {
                return fileName.toLowerCase().endsWith(validType.toLowerCase());
            }
            if (validType.endsWith('/*')) {
                return baseMimeType === validType.replace(/\/.*$/, '');
            }
            return mimeType === validType;
        });
    }
    return true;
}
function isDragEvent(event) {
    return dragEvents.indexOf(event.type) > 0;
}
function isChangeEvent(event) {
    return Object.prototype.hasOwnProperty.call(event, 'target');
}
//# sourceMappingURL=utils.js.map